export default "assets/arrow-fc46a636.svg";